import dayjs, { Dayjs } from 'dayjs';

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?Z)?$/;

const revive = (value: string): string | boolean | Dayjs => {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (ISO_DATE_PATTERN.test(value)) return dayjs(value);
    return value;
};

const serialize = (value: unknown): string => {
    if (dayjs.isDayjs(value)) return value.toISOString();
    return String(value);
};

export const readUrlFilters = (
    searchParams: URLSearchParams,
    keys: string[]
): Record<string, string | boolean | Dayjs> => {
    const filters: Record<string, string | boolean | Dayjs> = {};
    for (const key of keys) {
        const value = searchParams.get(key);
        if (value !== null) {
            filters[key] = revive(value);
        }
    }
    return filters;
};

export const writeUrlFilters = (
    searchParams: URLSearchParams,
    keys: string[],
    params: Record<string, unknown>
): URLSearchParams => {
    const next = new URLSearchParams(searchParams);
    for (const key of keys) {
        const value = params[key];
        if (value === undefined || value === null) {
            next.delete(key);
        } else {
            next.set(key, serialize(value));
        }
    }
    return next;
};
